module.exports = __webpack_public_path__ + "static/media/title-shop.5336deb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/client/shared/images/title-shop.png
// module id = 486
// module chunks = 0